// Libs
import React from 'react'

// CSS
import './styles.scss'

//Components
import Button from '../../../../components/Button'

const CaptureCardInsert = ({ form, forms, changeCardType, changeField, insertCase, loading }) => {
  const gridAreaArray = ['1 / 1 / 2 / 4', '2 / 1 / 3 / 4', '3 / 1 / 4 / 4', '1 / 4 / 4 / 8',]

  return (
    <div className='capture-card-insert__card'>
      {form.map((item, idx) => (
        <div
          key={idx}
          className={item.error ? 'capture-card-insert__info capture-card-insert__info--error' : 'capture-card-insert__info'}
          style={{ gridArea: gridAreaArray[idx] }}>
          <span>{item.label}</span>
          {!item.editable &&
            <div>{item.format ? item.format(item.value) : item.value}</div>
          }
          {item.editable && item.type === 'select' &&
            <select onChange={(e) => changeField(1, item.field, e.target.value, null, null)}>
              {item.options.map(option => {
                return (
                  <option
                    key={option.value}
                    value={option.value}>
                    {option.label}
                  </option>
                )
              })}
            </select>
          }
          {item.editable && item.type === 'textarea' &&
            <textarea onChange={(e) => changeField(1, 'message', e.target.value, null, null)} value={item.value}></textarea>
          }
        </div>
      ))}
      <div className='capture-card-insert__button--wrapper' style={{ gridArea: '5 / 6 / 6 / 7' }}>
        <Button
          resize={false}
          onClick={() => changeCardType('case')}>
          Voltar
        </Button>
      </div>
      <div className='capture-card-insert__button--wrapper' style={{ gridArea: '5 / 7 / 6 / 8' }}>
        <Button
          type="submit"
          resize={false}
          localLoading={loading}
          onClick={() => insertCase(forms)}>
          Confirmar
        </Button>
      </div>
    </div>
  )
}

export default CaptureCardInsert
